<script setup lang="ts">
import { BankAccountStatus } from '../../../../typings'
import { CheckCircleIcon, DotsCircleHorizontalIcon, ExclamationCircleIcon, XCircleIcon } from '@heroicons/vue/solid'
import { i18n } from '../../../../localization'
import { computed, ConcreteComponent, RenderFunction } from 'vue'

const props = defineProps<{
    status: BankAccountStatus
}>()

interface BankAccountStatusProps {
    icon: RenderFunction | ConcreteComponent
    text: string
    class: string
    textClass: string
}

const verificationStatusOptions: { [key in BankAccountStatus]: BankAccountStatusProps } = {
    [BankAccountStatus.VERIFICATION_PENDING]: {
        icon: DotsCircleHorizontalIcon,
        text: i18n.global.t('bank_account.in_progress'),
        class: 'text-blue-400',
        textClass: 'text-blue-900',
    },
    [BankAccountStatus.VERIFIED]: {
        icon: CheckCircleIcon,
        text: i18n.global.t('bank_account.accepted'),
        class: 'text-green-500',
        textClass: 'text-green-900',
    },
    [BankAccountStatus.REJECTED]: {
        icon: XCircleIcon,
        text: i18n.global.t('bank_account.rejected'),
        class: 'text-red-400',
        textClass: 'text-red-900',
    },
    [BankAccountStatus.EXPIRED]: {
        icon: ExclamationCircleIcon,
        text: i18n.global.t('bank_account.expired'),
        class: 'text-orange-400',
        textClass: 'text-orange-900',
    },
}

const currentOptions = computed(() => verificationStatusOptions[props.status])
</script>

<template>
    <div class="flex items-center space-x-2">
        <div :class="currentOptions.textClass">{{ currentOptions.text }}</div>
        <Component :is="currentOptions.icon" class="h-5 w-5" :class="currentOptions.class"></Component>
    </div>
</template>
